import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VerificationBankDetailComponent } from './verification-bank-detail/verification-bank-detail.component';
import { VerificationBankComponent } from './verification-bank.component';

const routes: Routes = [
  {
    path: '',
    component: VerificationBankComponent
  },
  {
    path: 'details/:id',
    component: VerificationBankDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerificationBankRoutingModule { }
